export default __webpack_public_path__ + "static/media/kristie bruce.64076030.jpg";